import { useAuthenticatedContext } from "#src/contexts/AuthenticatedContext.helpers";
import * as Sentry from "@sentry/react";
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { AuthenticationLayouts } from "../batteries-included-components/Layouts/Authentication";
import AuthenticatedPage from "../components/Layout/AuthenticatedPage";
import Layout from "../components/Layout/Layout";
import { saveEntryLocation } from "../components/Redux/actions/authentication";
import { linkToLogin } from "./links";

const SentryRoute = Sentry.withSentryRouting(Route);

const mapStateToProps = ({ authentication }) => {
  return {
    isLoggedIn: authentication.isLoggedIn,
  };
};

const mapDispatchToProps = {
  saveEntryLocation,
};

// IMPROVE: this component is unnecessary and also does not adhere to how <Route />
// components must be rendered within a <Switch />. They must be direct
// children... not within another component like here. This <Route /> is also
// duplicated further down the tree... which is a code smell. All this and more
// will be tackled in the routing engine overhaul to come. (https://validere.atlassian.net/browse/CHB-2026)
export const PrivateRoute = ({
  path,
  isLoggedIn,
  saveEntryLocation,
  ...rest
}) => {
  const authContext = useAuthenticatedContext();

  return (
    <SentryRoute
      path={path}
      exact
      {...rest}
      render={(props) => {
        const v2IsLoggedIn = authContext.isLoggedIn;
        if (
          (!isLoggedIn && authContext.activeAuthVersion.includes("v1")) ||
          v2IsLoggedIn === false
        ) {
          saveEntryLocation(props.location);
          return (
            <Redirect
              to={{
                pathname: linkToLogin(),
                state: { from: props.location },
              }}
            />
          );
        }
        if (
          v2IsLoggedIn === null &&
          authContext.activeAuthVersion.includes("v2")
        )
          return <AuthenticationLayouts.VerifyingOnLoginLayout />;

        return (
          <AuthenticatedPage>
            <Layout {...props} />
          </AuthenticatedPage>
        );
      }}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
